import React, { useMemo } from 'react';
import _ from 'lodash';
import ProviderField from '../ProviderFields';
import * as types from '../../reducer/constants';
import { getProviderFormService, checkModalSubscription } from '../../helper';

import { getProvider } from '../../../../../helpers/getters';

/* eslint-disable react/prop-types */
const Provider = (props) => {
  const { providerForm, errorProvider, isLoadingProvider, form, dispatchServiceData, modal } = props;
  const { provider_id, provider_service_id, custom_fields } = form;

  const customFields = _.isArray(custom_fields) || _.isNull(custom_fields) ? null : custom_fields;
  const isModalSubscription = useMemo(() => checkModalSubscription(modal), [modal]);

  const onChangeProviderId = (value) => {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_PROVIDER_ID, value })
  };

  const onChangeProviderServiceId = (value) => {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_PROVIDER_SERVICE_ID, value })
    const service = getProviderFormService(value, providerForm);
    const provider = getProvider(provider_id);

    /**
     * Если service_refill = false
     * Сбрасываем все настройки рефилла
     * refill не будет отображаться
     */
    if (service?.hasOwnProperty('service_refill')) {
      const { service_refill } = service;
      if (!service_refill) {
        dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_OFF })
      }
    }
    /**
     * Если service_cancel = false
     * Сбрасываем все настройки рефилла
     * cancel не будет отображаться
     */
    if (service?.hasOwnProperty('service_cancel')) {
      const { service_cancel } = service;
      if (service_cancel) {
        dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_CANCEL, value: service_cancel })
      }
      if (!service_cancel && !provider.cancel) {
        dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_CANCEL, value: service_cancel })
      }
    }

    /**
     * Если service_dripfeed = false
     * Сбрасываем все настройки рефилла
     * service_dripfeed не будет отображаться
     */
    if (service?.hasOwnProperty('service_dripfeed')) {
      const { service_dripfeed } = service;
      if (!service_dripfeed) {
        dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_DRIP_FEED, value: service_dripfeed })
      }
    }

    /**
     * Если выбран Choose service
     * Сбрасываем sync rate
     */
    if (_.isNull(service)) {
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_RATE, value: false })
    }

    /**
     * Если выбранный сервис subscription
     * то надо не передавать subscription_type
     * Только если до этого, сервисы НЕ БЫЛ subscription
     * subscription_type = null
     */
    if (service && !isModalSubscription) {
      if (service.service_type === 100 || service.service_type === 101) {
        dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SUBSCRIPTION_TYPE, value: null })
      }
    }

    /**
     * Если выбранный сервис subscription
     * и включен deny_duplicates
     * deny_duplicates = false
     * overflow = 0
     * increment = null
     */
    if (service) {
      if (service.service_type === 100 || service.service_type === 101) {
        dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_DENY_DUPLICATES, value: false })
        dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_OVERFLOW, value: 0 })
        dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_INCREMENT, value: null })
      }
    }

    /**
     * Автоматически врубаем auto_min, auto_max, auto_rate, auto_status, auto_increment
     * Если сервис поддерживает
     */
    if (_.isNull(provider_service_id) || provider_service_id === '') {
      if (provider) {
        if (provider.service_auto_max) {
          dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_MAX, value: true })
        }
        if (provider.service_auto_min) {
          dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_MIN, value: true })
        }
        if (provider.service_auto_rate) {
          dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_RATE, value: true })
        }
        if (provider.service_auto_status) {
          dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_STATUS, value: true })
        }
        if (provider.service_auto_increment) {
          dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_INCREMENT, value: true })
        }
      }
    }

    /**
     * Если выбран Choose service
     * Отменяем все sync
     */
    if (value === '' && providerForm?.provider_service_id?.field_type === 'select') {
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_MAX, value: false })
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_MIN, value: false })
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_RATE, value: false })
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_STATUS, value: false })
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_INCREMENT, value: false })
    }

    /**
     * Если были включены Auto complete и Start count parsing
     * Выключаем их
     */
    if (service) {
      if (service.service_type === 100 || service.service_type === 101) {
        dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_AUTO_COMPLETE, value: false })
        dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_START_COUNT, value: 0 })
      }
    }
  };

  const onChangeCustomField = (fieldKey, fieldValue) => {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_CUSTOM_FIELDS, key: fieldKey, value: fieldValue })
  }

  return (
    <>
      <ProviderField
        isLoading={isLoadingProvider}
        form={form}
        modal={modal}
        providerForm={providerForm}
        error={errorProvider}
        customFieldsValues={customFields}
        providerId={provider_id}
        providerServiceId={provider_service_id}
        onChangeProviderId={onChangeProviderId}
        onChangeProviderServiceId={onChangeProviderServiceId}
        onChangeCustomField={onChangeCustomField}
      />
    </>
  )
}

export default Provider;
